// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"aa2671be","488":"ba4caea6","977":"08934997"}[chunkId] + ".chunk.js";
};